import React from "react";
import { Award, Trophy, BadgeCheck, ShieldCheck, FileBadge, Medal, Plane, BookOpen, FileCheck2 } from "lucide-react";
import { CREDENTIALS, AWARDS } from "../mock";

const ICONS = [Award, ShieldCheck, Trophy, BadgeCheck, FileCheck2, Medal, Plane, BookOpen, FileBadge];

const WhyCCPL = () => {
  return (
    <section id="why" className="py-14 md:py-24 bg-[#0b1220]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">
          Why Competitive Careers
        </div>
        <h2 className="mt-3 text-center text-white text-[34px] md:text-[44px] font-semibold leading-[1.1] tracking-tight">
          Ahmedabad's <span className="text-amber-400">#1 Study Abroad</span> Consultant
        </h2>
        <p className="mt-4 text-center text-slate-300 max-w-2xl mx-auto">
          23+ years of unmatched excellence. Awarded by Gujarat's Chief Minister. Certified by international education bodies. Trusted by 8,000+ students.
        </p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CREDENTIALS.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={c.title}
                className="rounded-2xl cc-card p-5 flex items-center gap-4 transition-transform duration-300 hover:-translate-y-0.5"
              >
                <div className="h-12 w-12 rounded-xl bg-amber-500/10 grid place-items-center border border-amber-500/20 flex-shrink-0">
                  <Icon className="h-5 w-5 text-amber-400" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-white text-[15.5px] font-semibold truncate">{c.title}</h3>
                    <span className="inline-flex items-center rounded-full bg-red-500/12 text-red-300 border border-red-500/30 px-2 py-0.5 text-[10px] tracking-[0.14em] uppercase font-semibold">
                      {c.badge}
                    </span>
                  </div>
                  <p className="mt-1 text-slate-300 text-[13.5px]">{c.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Awards */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 mt-24">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">
          Awards &amp; Recognition
        </div>
        <h2 className="mt-3 text-center text-white text-[30px] md:text-[40px] font-semibold leading-[1.1] tracking-tight">
          Honoured by leaders, recognised by media
        </h2>

        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {AWARDS.map((a) => (
            <div
              key={a.title}
              className="rounded-2xl cc-card p-6 transition-transform duration-300 hover:-translate-y-0.5"
            >
              <div className="h-12 w-12 rounded-xl bg-amber-500/10 grid place-items-center border border-amber-500/20">
                <Trophy className="h-5 w-5 text-amber-400" />
              </div>
              <h3 className="mt-5 text-white text-[16px] font-semibold leading-snug">{a.title}</h3>
              <p className="mt-2 text-slate-300 text-[13.5px]">{a.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyCCPL;
